import moment from "moment";

const dateParser = (rawDate) => ({
  value: rawDate ? moment(rawDate) : rawDate
});

export { dateParser };
